import { formatCurrencyFromCents } from "@simplyk/common";

import { AssistantPaymentCard } from "./parsePaymentCards";

import { useLocaleContext } from "@/common/contexts/LocaleContext";

export const usePaymentCardFormat = () => {
  const { locale, isoLocale } = useLocaleContext();
  return (payment: AssistantPaymentCard) => ({
    date: new Date(payment.date).toLocaleDateString(locale, { month: "short", day: "numeric", year: "numeric" }),
    amount: formatCurrencyFromCents(payment.amountInSmallestUnit, { isoLocale, currency: payment.currency }),
  });
};
